export default __webpack_public_path__ + "static/media/photo--sm--kickoff4.17087d1f.jpg";